import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { CannyProvider, CannyFeedback } from "react-canny";
import { SkeletonGrid, Skeleton } from "components/ui/skeleton/UISkeleton";
import { getTenantFromToken } from "config/helpers/common_helper";

const APP_ID = process.env.REACT_APP_CANNY_APP_ID;
const BOARD_TOKEN = process.env.REACT_APP_CANNY_BOARD_TOKEN;

const CannyWidgetFR = ({ theme }) => {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const containerRef = useRef(null);

  // Get state from Redux
  const { ssoToken } = useSelector((state) => state.canny);
  const currentUser = useSelector((state) => state?.auth?.userData?.resource);
  const tenantID = getTenantFromToken();

  const cannyUser = currentUser
    ? { id: tenantID, name: currentUser.name, email: currentUser.email }
    : null;

  useEffect(() => {
    // Reset iframe loaded state when ssoToken changes (new dialog open)
    setIframeLoaded(false);

    const observer = new MutationObserver(() => {
      const iframe = containerRef.current?.querySelector("iframe");
      if (iframe) {
        iframe.onload = () => {
          setIframeLoaded(true);
        };
        observer.disconnect();
      }
    });

    if (containerRef.current) {
      observer.observe(containerRef.current, {
        childList: true,
        subtree: true,
      });
    }

    return () => observer.disconnect();
  }, [ssoToken]);

  if (!cannyUser || !ssoToken) return null;

  return (
    <CannyProvider appId={APP_ID}>
      <div
        ref={containerRef}
        style={{ position: "relative", minHeight: "400px" }}
      >
        {!iframeLoaded && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 10,
              padding: "16px",
              boxSizing: "border-box",
              backgroundColor: theme === "dark" ? "#23224F" : "#fff",
              overflowY: "hidden",
            }}
          >
            <SkeletonGrid spacing={2}>
              <Skeleton type="text" rows={2} height={20} col={12} radius={4} />
              <Skeleton type="text" rows={1} height={20} col={6} radius={4} />
              <Skeleton type="text" rows={1} height={20} col={6} radius={4} />
              <Skeleton type="image" height={180} col={12} radius={8} />
              <Skeleton type="image" height={180} col={12} radius={8} />
            </SkeletonGrid>
          </div>
        )}

        <CannyFeedback
          boardToken={BOARD_TOKEN}
          ssoToken={ssoToken}
          theme={theme}
          user={cannyUser}
        />
      </div>
    </CannyProvider>
  );
};

export default CannyWidgetFR;